module.exports = __webpack_public_path__ + "static/media/loginpic3.f06eaf97.jpg";